import { lazy, Suspense, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Footer from '../components/footer/Footer';
import Spinner from '../components/spinner/Spinner';
import HeaderNotification from '../components/promotionHeader/HeaderNotification';
import { styles } from '../core/constants';
import routes from '../routes';
import { siteRegion, siteUrl } from '../core/config';
import './app.scss';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLandingMedia } from '../core/slices/landginMediaSlice';
import i18n from '../i18n';

// Dynamic Page Load
const MainLanding = lazy(() => import('../pages/MainLanding'));
const PersonalAccount = lazy(() => import('../pages/PersonalAccount'));
const UserAgreementRu = lazy(() => import('../pages/juridicalPages/UserAgreementRu'));
const UserAgreementUz = lazy(() => import('../pages/juridicalPages/UserAgreementUz'));
const PrivacyPolicyRu = lazy(() => import('../pages/juridicalPages/PrivacyPolicyRu'));
const PrivacyPolicyUz = lazy(() => import('../pages/juridicalPages/PrivacyPolicyUz'));
const PersonalPolicy = lazy(() => import('../pages/juridicalPages/PersonalPolicy'));
const ThanksForPayment = lazy(() => import('../pages/ThanksForPayment'));
const UfsBaku = lazy(() => import('../pages/UfsBaku'));
const Page404 = lazy(() => import('../pages/Page404'));

const t = i18n.t;

function App() {
  const dispatch = useDispatch();
  const { features } = useSelector((state) => state.media.data);

  useEffect(() => {
    dispatch(fetchLandingMedia());
  }, [dispatch]);

  return (
    <Suspense
      fallback={
        <Spinner
          styles={{
            typeOfSpinner: styles.redSpinnerClass,
            wrapperStyles: { marginTop: '200px' },
          }}
        />
      }
    >
      <Helmet>
        <meta http-equiv='X-UA-Compatible' content='IE=edge' />
        <meta
          name='description'
          content={t('components.app.description')}
        />
        <meta name='yandex-verification' content='eadd78ca9d04cdae' />
        <link
          href='https://assets-global.website-files.com/5cf5a026c170934c311c121c/5d925f57042e0b00590488bc_UFC_app_icon_favicon.png'
          rel='shortcut icon'
          type='image/x-icon'
        />
        <link rel='canonical' href={siteUrl}/>
        <title>{t('components.app.title')}</title>
      </Helmet>
      <Router>
        <div className='app'>
          {/*<HeaderWithNotification features={features} />*/}
          <main>
            <Routes>
              <Route path={routes.main} element={<MainLanding />} />
              <Route path={routes.account} element={<PersonalAccount />} />
              <Route path={routes.privacy} element={siteRegion === 'ru' ? <PrivacyPolicyRu /> : <PrivacyPolicyUz/>} />
              <Route path={routes.agreement} element={siteRegion === 'ru' ? <UserAgreementRu /> : <UserAgreementUz/>} />
              <Route path={routes.personalPolicy} element={<PersonalPolicy />} />
              <Route path={routes.thanksForPayment} element={<ThanksForPayment />} />
              <Route path={routes.tickets_baku} element={<UfsBaku />} />
              <Route path='*' element={<Page404 />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </Suspense>
  );
}

function HeaderWithNotification({ features }) {
  const location = useLocation();
  // Remove HeaderNotification for Baku page
  const isBakuPage = location.pathname === routes.tickets_baku;

  return (
    <>
      {!isBakuPage && features?.scim?.enabled && (
        <div className='flexed-btn'>
          <HeaderNotification text={t('components.notification.header')} linkText={t('components.notification.btn')} link='/tickets_baku' />
        </div>
      )}
    </>
  );
}

export default App;